import React from 'react'
import PropTypes from 'prop-types'
import { Icons } from 'icons'
import { ChatBubbleOutline } from '@material-ui/icons'
import { ButtonBubble } from '../Call/ButtonBubble'
import { ChatAccordionArrow, ChatAccordionButton } from './style'
import { useAmplifyChat } from '@gojiraf/chat'

export const ChatAccordion = ({ handleClick, chatOpen }) => {
  const { state: chatState } = useAmplifyChat()

  return (
    <ChatAccordionButton type="button" onClick={() => handleClick(!chatOpen)}>
      {chatState.newMessagesCount && !chatOpen ? (
        <ButtonBubble badgeContent={chatState.newMessagesCount} color="error">
          <ChatBubbleOutline />
        </ButtonBubble>
      ) : (
        <ChatBubbleOutline />
      )}
      <span>Chat</span>
      <ChatAccordionArrow rotate={chatOpen}>
        <Icons.Expand color="white" />
      </ChatAccordionArrow>
    </ChatAccordionButton>
  )
}

ChatAccordion.propTypes = {
  chatOpen: PropTypes.bool,
  handleClick: PropTypes.func,
}
